import "./TblSelect.css";
import { useTblInfo, regUses } from "../../axios_with_token";

export default function TblSelect({fldName, form, fldDef, opts:optsIn}){
    const {regUse, isReady} = regUses();
    const {data:tblInfo} = regUse(useTblInfo());
    const opts = {...optsIn};

    return isReady()&&<select
        className="form-control"
        {...form.register(fldName, opts.formOpts)}
    >{
        Object.keys(tblInfo).map(tblName=><option
            key={tblName}
        >{tblName}</option>)
    }</select>
}